export default __webpack_public_path__ + "static/media/111.d3403bd7.gif";